import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Select,
  Tabs,
  Typography,
} from "antd";
import destinationsApi from "../../api/destinations";
import { useIntl } from "react-intl";
import _, { debounce } from "lodash";
import IntlMessage from "../../components/IntlMessage";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { PlusOutlined } from "@ant-design/icons";
import routesApi from "../../api/route";
import { route_markets } from "../../utils/constant";
import { useMounted } from "../../hooks/useMounted";
import vehiclesApi from "../../api/vehicle";
import { useSelector } from "react-redux";

const { Option } = Select;
const { Text } = Typography;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const RouteForm = (props) => {
  const { open, onClose, currentData } = props;
  const operator_data = useSelector((state) => state.auth.operator);
  const { isMounted } = useMounted();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const [vehicles, setVehicles] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState(null);
  const [startLocationId, setStartLocationId] = useState(null);
  const [endLocationId, setEndLocationId] = useState(null);
  const [maps, setMaps] = useState([]);
  const [startLocation, setStartLocation] = useState(null);
  const [endLocation, setEndLocation] = useState(null);
  const operator = useSelector((state) => state.auth.operator);

  const initialValues = {
    ...currentData,
    vehicle_id: currentData?.seatmap?.id ?? null,
    start_loc_id: currentData?.start_location?.id ?? null,
    end_loc_id: currentData?.end_location?.id ?? null,
    status: currentData && currentData.status ? 1 : 0,
    meta_data:
      currentData && currentData.markets
        ? _.values(route_markets).map((key) => ({
            [key]:
              currentData && currentData.markets
                ? JSON.parse(currentData.markets)[key] || null
                : null,
          }))
        : _.values(route_markets) &&
          _.values(route_markets).map((key) => ({
            [key]: null,
          })),
  };

  useEffect(() => {
    if (currentData) {
      setStartLocation(currentData?.start_location?.id ?? null);
      setEndLocation(currentData?.end_location?.id ?? null);
      if (currentData?.maps) {
        const currentMap = currentData?.maps?.split(",")?.map((v) => Number(v));
        if (Array.isArray(currentMap) && currentMap.length >= 2) {
          setMaps((prev) => {
            const values = currentMap.slice(1, currentMap.length - 1);
            return values;
          });
        }
      }
    }
  }, [currentData]);

  const fetch = useCallback(async () => {
    if (isMounted.current) {
      const filter = {
        limit: 9999,
        page: 1,
        order_by: "title",
        order_dir: "ASC",
      };
      const payload = {
        page: 1,
        limit: 9999,
        keyword: "",
        order_by: "title",
        order_dir: "ASC",
        filter_name: ["operator_id"],
        filter_value: [currentData?.operator?.id || operator?.id],
      };
      const res = await vehiclesApi.getAll(payload);
      const vehicleData = res?.data;
      if (Array.isArray(vehicleData)) {
        setVehicles(vehicleData);
      }

      const destinationRes = await destinationsApi.getAll(filter);
      const destinationData = destinationRes?.data;
      if (Array.isArray(destinationData)) {
        const destinationOptions = destinationData.map((d) => ({
          ...d,
          label: `${d?.title}`,
          value: d?.id,
        }));
        setDestinations(destinationOptions);
      }
    }
  }, [isMounted]);
  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        delete data.destinations;

        const mapsData = _.concat(startLocation, maps, endLocation);
        data["maps"] = mapsData.join(",");
        let combinedObject = {};
        currentData &&
          data.meta_data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              combinedObject[key] = item[key];
              console.log(item[key]);
            });
          });

        if (combinedObject) {
          data = {
            ...data,
            markets: JSON.stringify(combinedObject),
          };
        }

        data.operator_id = operator_data?.id;

        const payload = _.cloneDeep(data);

        if (currentData) {
          routesApi
            .update(currentData.id, payload)
            .then((res) => {
              if (res?.statusCode === 400) {
                Modal.error({
                  title: res?.message,
                  okText: intl.formatMessage({ id: "global.close" }),
                });
                setLoading(false);
              } else {
                setLoading(false);
                message.success("Updated successfully!");
                handleCancel();
                props.onReload();
              }
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        } else {
          routesApi
            .create(payload)
            .then((res) => {
              if (res?.statusCode === 400) {
                Modal.error({
                  title: res?.message,
                  okText: intl.formatMessage({ id: "global.close" }),
                });
                setLoading(false);
              } else {
                setLoading(false);
                message.success("Created successfully!");
                handleCancel();
                props.onReload();
              }
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  const handleCancel = () => {
    onClose();
  };

  const handleSearchVehicle = debounce(async (value) => {
    try {
      if (operatorSelected) {
        const payload = {
          page: 1,
          limit: value === "" ? 10 : 9999,
          keyword: value || "",
          order_by: "title",
          order_dir: "ASC",
          filter_name: ["operator_id"],
          filter_value: [operator?.id],
        };
        const res = await vehiclesApi.getAll(payload);
        const vehicleData = res?.data;
        if (Array.isArray(vehicleData)) {
          setVehicles(vehicleData);
        }
      } else {
        setVehicles([]);
      }
    } catch (error) {
      console.error(error);
    }
  }, 300);

  const onChangeVehicle = async (e) => {};

  const handleSearchDestination = debounce(async (value) => {
    try {
      const payload = {
        page: 1,
        limit: value === "" ? 10 : 9999,
        keyword: value || "",
        order_by: "title",
        order_dir: "ASC",
      };
      const res = await destinationsApi.getAll(payload);
      const destinationData = res?.data;
      if (Array.isArray(destinationData)) {
        const destinationOptions = destinationData.map((d) => ({
          ...d,
          label: `${d?.title}`,
          value: d?.id,
        }));
        setDestinations(destinationOptions);
      }
    } catch (error) {
      console.error(error);
    }
  }, 300);

  const onChangeStartLocation = (e) => {
    setStartLocation(e);
    setStartLocationId(e);
  };

  const onChangeEndLocation = (e) => {
    setEndLocation(e);
    setEndLocationId(e);
  };

  const onChecked = (e) => {};

  const tabItems = [
    {
      key: "1",
      label: <IntlMessage id="global.routes" />,
      children: (
        <React.Fragment>
          <Form.Item
            name="vehicle_id"
            label={<IntlMessage id="global.vehicle" />}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              showSearch
              onChange={onChangeVehicle}
              filterOption={false}
              onSearch={handleSearchVehicle}
              placeholder={intl.formatMessage({
                id: "placeholder.select_vehicle",
              })}
              // disabled={!operatorSelected}
            >
              {vehicles.map((item, index) => {
                return (
                  <Option value={item.id} key={index}>
                    {item?.title}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            name="start_loc_id"
            label={<IntlMessage id="global.start_location" />}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              showSearch
              onChange={onChangeStartLocation}
              filterOption={false}
              onSearch={handleSearchDestination}
              placeholder={intl.formatMessage({
                id: "placeholder.select_start_location",
              })}
            >
              {destinations
                .filter((value) => value?.value !== endLocationId)
                .map((item, index) => {
                  return (
                    <Option value={item.value} key={index}>
                      {item.label}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            name="end_loc_id"
            label={<IntlMessage id="global.end_location" />}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              showSearch
              onChange={onChangeEndLocation}
              filterOption={false}
              onSearch={handleSearchDestination}
              placeholder={intl.formatMessage({
                id: "placeholder.select_end_location",
              })}
            >
              {destinations
                .filter((value) => value?.value !== startLocation)
                .map((item, index) => {
                  return (
                    <Option value={item.value} key={index}>
                      {item.label}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                whitespace: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input placeholder="Input title" />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.sku" />}
            name="sku"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input placeholder="Input sku" />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.duration" />}
            name="duration"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input placeholder="10:0" />
          </Form.Item>

          <Form.Item label={<IntlMessage id="global.destination_map" />}>
            <MapsForm
              isMounted={isMounted}
              maps={maps}
              setMaps={setMaps}
              startLocation={startLocation}
              endLocation={endLocation}
            />
          </Form.Item>

          <Form.Item label={<IntlMessage id="global.status" />} name="status">
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
        </React.Fragment>
      ),
    },
    {
      key: "2",
      label: <IntlMessage id="global.description" />,
      forceRender: true,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.description" />}
            name="description"
            rules={[
              {
                required: false,
              },
            ]}
            // valuePropName="data"
            // getValueFromEvent={(event, editor) => {
            //   const data = editor.getData();
            //   return data;
            // }}
          >
            {/* <CKEditor editor={ClassicEditor} /> */}
            <Input.TextArea
              placeholder="Input description"
              autoSize={{ minRows: 6 }}
            />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.cancel_policy" />}
            name="cancel_policy"
            rules={[
              {
                required: false,
              },
            ]}
            // valuePropName="data"
            // getValueFromEvent={(event, editor) => {
            //   const data = editor.getData();
            //   return data;
            // }}
          >
            {/* <CKEditor editor={ClassicEditor} /> */}
            <Input.TextArea
              placeholder="Input cancel policy"
              autoSize={{ minRows: 6 }}
            />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.policy" />}
            name="policy"
            rules={[
              {
                required: false,
              },
            ]}
            // valuePropName="data"
            // getValueFromEvent={(event, editor) => {
            //   const data = editor.getData();
            //   return data;
            // }}
          >
            {/* <CKEditor editor={ClassicEditor} /> */}
            <Input.TextArea
              placeholder="Input policy"
              autoSize={{ minRows: 6 }}
            />
          </Form.Item>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.route_markets" />,
      key: "3",
      forceRender: true,
      children: (
        <>
          <Form.List name="meta_data">
            {(fields, { add }) => {
              return (
                <>
                  {fields.map((field, index) => {
                    const fieldName = _.values(route_markets)[index];

                    return (
                      <Form.Item
                        label={<IntlMessage id={`global.${fieldName}`} />}
                        name={[index, fieldName]}
                        key={field.key}
                      >
                        <Checkbox.Group
                          style={{
                            width: "100%",
                          }}
                        >
                          <Checkbox
                            onChange={onChecked}
                            value={fieldName}
                          ></Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    );
                  })}
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={open}
        destroyOnClose={true}
        onCancel={handleCancel}
        width="80%"
        onOk={handleSubmit}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessage id="global.cancel" />}
          </Button>,
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={handleSubmit}
          >
            {<IntlMessage id="global.save" />}
          </Button>,
        ]}
      >
        <Form
          {...layout}
          form={form}
          initialValues={initialValues}
          labelAlign="left"
          onFinish={handleSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

const MapsForm = (props) => {
  const { isMounted, maps, setMaps, startLocation, endLocation } = props;

  const [startLocationTitle, setStartLocationTitle] = useState("");
  const [endLocationTitle, setEndLocationTitle] = useState("");

  const fetch = useCallback(async () => {
    if (isMounted.current && startLocation && endLocation) {
      const filter = {
        limit: 9999,
        page: 1,
        order_by: "title",
        order_dir: "ASC",
      };

      const destinationRes = await destinationsApi.getAll(filter);
      const destinationData = destinationRes?.data;
      if (Array.isArray(destinationData)) {
        setStartLocationTitle(
          _.find(destinationData, (d) => d.id === startLocation)?.title
        );
        setEndLocationTitle(
          _.find(destinationData, (d) => d.id === endLocation)?.title
        );
      }
    }
  }, [isMounted, startLocation, endLocation]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleAddDestination = () => {
    setMaps((prev) => {
      prev.push(null);
      return _.cloneDeep(prev);
    });
  };

  const handleChangeDestination = (value, index) => {
    setMaps((prev) => {
      _.set(prev, index, value);
      return _.cloneDeep(prev);
    });
  };

  return (
    <React.Fragment>
      {!startLocation || !endLocation ? (
        <IntlMessage id="global.please_select_start_and_stop_destination" />
      ) : (
        <Flex vertical gap={8}>
          <Flex gap={4}>
            <Text strong>1.</Text>
            <Text>{startLocationTitle}</Text>
          </Flex>
          {maps.map((level, index) => (
            <Flex key={index} gap={8} align="center">
              <Text strong style={{ wordBreak: "normal" }}>
                {index + 2}.
              </Text>
              <SelectDestinationItem
                isMounted={isMounted}
                handleChangeDestination={handleChangeDestination}
                selectIndex={index}
                value={level}
              />
            </Flex>
          ))}
          <Flex gap={4}>
            <Text strong>{maps.length + 2}.</Text>
            <Text>{endLocationTitle}</Text>
          </Flex>
          <Flex>
            <Button
              type="default"
              // icon={<PlusOutlined />}
              shape="round"
              onClick={handleAddDestination}
            >
              <IntlMessage id="global.add_stop" />
            </Button>
          </Flex>
        </Flex>
      )}
    </React.Fragment>
  );
};

const SelectDestinationItem = (props) => {
  const { isMounted, handleChangeDestination, selectIndex, value } = props;

  const [destinations, setDestinations] = useState([]);

  const fetch = useCallback(async () => {
    if (isMounted.current) {
      const filter = {
        limit: 9999,
        page: 1,
        order_by: "title",
        order_dir: "ASC",
      };

      const destinationRes = await destinationsApi.getAll(filter);
      const destinationData = destinationRes?.data;
      if (Array.isArray(destinationData)) {
        const destinationOptions = destinationData.map((d) => ({
          ...d,
          label: `${d?.title}`,
          value: d?.id,
        }));
        setDestinations(destinationOptions);
      }
    }
  }, [isMounted]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleSearchDestination = debounce(async (value) => {
    try {
      const payload = {
        page: 1,
        limit: value === "" ? 10 : 9999,
        keyword: value || "",
        order_by: "title",
        order_dir: "ASC",
      };
      const res = await destinationsApi.getAll(payload);
      const destinationData = res?.data;
      if (Array.isArray(destinationData)) {
        const destinationOptions = destinationData.map((d) => ({
          ...d,
          label: `${d?.title}`,
          value: d?.id,
        }));
        setDestinations(destinationOptions);
      }
    } catch (error) {
      console.error(error);
    }
  }, 300);

  return (
    <Select
      showSearch
      filterOption={false}
      onSearch={handleSearchDestination}
      defaultValue={value}
      onChange={(value) => handleChangeDestination(value, selectIndex)}
      placeholder="Select location"
    >
      {destinations.map((item, index) => {
        return (
          <Option value={item.value} key={index}>
            {item.label}
          </Option>
        );
      })}
    </Select>
  );
};

export default RouteForm;
